import React from "react";
import { Link } from "react-router-dom";
import { BrainCircuit, MessageCircle, Users } from "lucide-react";
import WhatsAppCommunityCard from "../components/WhatsAppCommunityCard";
import "./communityVoice.css";

export default function CommunityVoice() {
  return (
    <div className="cv-page">
      <section className="cv-hero">
        <Users size={46} aria-hidden="true" />
        <p className="cv-kicker">UUN Community Voice</p>
        <h1>Your voice can shape your neighbourhood</h1>
        <p>Urban Unity Network listens to residents so local priorities guide practical action and stronger partnerships.</p>
      </section>

      <section className="cv-survey-list" aria-labelledby="open-surveys-heading">
        <h2 id="open-surveys-heading">Have your say</h2>
        <div className="cv-dashboard-grid">
          <article className="cv-card cv-survey-card">
            <BrainCircuit size={34} aria-hidden="true" />
            <p className="cv-kicker">New · approximately 3 minutes</p>
            <h3>AI, coding and digital skills</h3>
            <p>Tell UUN which free or affordable workshops would help you, your family, your work or your business.</p>
            <Link className="cv-button" to="/community-voice/ai-digital-skills">Take the digital skills survey</Link>
          </article>
          <article className="cv-card cv-survey-card">
            <MessageCircle size={34} aria-hidden="true" />
            <p className="cv-kicker">Barkantine Festival 2026</p>
            <h3>Help shape the Barkantine area</h3>
            <p>Share local priorities for activities, services, events and community projects.</p>
            <Link className="cv-button cv-secondary" to="/community-voice/barkantine-festival-2026">Take the Festival survey</Link>
          </article>
        </div>
      </section>

      <section className="cv-card">
        <h2>What your feedback helps shape</h2>
        <div className="cv-grid">
          {["Local activities", "Community services", "Youth provision", "Health and wellbeing programmes", "Employment and skills support", "Community events", "Partnerships with housing associations, councils, developers and local organisations"].map((item) => <div key={item}>{item}</div>)}
        </div>
        <p><MessageCircle size={18} aria-hidden="true" /> Surveys help UUN hear directly from the communities it serves.</p>
      </section>

      <WhatsAppCommunityCard title="Join the UUN Community" description="Keep up to date with local events, services, consultations, opportunities and ways to get involved." source="community-voice-landing" />
    </div>
  );
}
